export default {
  close: {
    id: 'outlet_inspect_close',
    defaultMessage: 'Close',
  },
}
